export default [
  {
    path: '/validador-laudos',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Validador de Laudos Histórico',
        path: 'historico',
        component: () => import('@/views/validadorLaudos/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Power Ups', path: '/powerups' }, { name: 'Validador de Laudos' }]
        }
      },
      {
        name: 'Validador de Laudos Editar',
        path: 'edit/:id',
        component: () => import('@/views/validadorLaudos/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Validador de Laudos', path: '/validador-laudos/historico' },
            { name: 'Editar' }
          ]
        }
      },
      {
        name: 'Validador de Laudos Adicionar',
        path: 'edit',
        component: () => import('@/views/validadorLaudos/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Validador de Laudos', path: '/validador-laudos/historico' },
            { name: 'Adicionar' }
          ]
        }
      }
    ]
  }
];
